define('app/sdc/push/sdc-push-service',["jquery"], function ($) {

	function Channel(name, channel, options) {
		Object.defineProperties(this, (function (options) {
			return {
				name: { value: name },
				canListen: !!options.canListen,
				canSend: !!options.send,
				send: (function channelSend() {
					if (!this.canSend) {
						throw new Error('The Channel "' + name + '" cannot send messages.')
					}
				}).bind(this)
			};
		}({ canListen: options.canListen, send: options.send, channel: channel })));
	}

});
